import { Skeleton } from '@/components/ui/skeleton.tsx'

export const RebillMessagesSkeleton = () => {
  return (
    <div className="w-full">
      <Skeleton className="mt-2 h-[400px] w-full animate-pulse rounded-md bg-skeleton" />
    </div>
  )
}
